var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRefresh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5195 11.5625C11.8711 11.5625 12.1641 11.4453 12.3887 11.2109L16.3828 7.16797C16.6562 6.89453 16.793 6.58203 16.793 6.2207C16.793 5.87891 16.6465 5.53711 16.3828 5.27344L12.3984 1.2207C12.1641 0.966797 11.8711 0.849609 11.5195 0.849609C10.8164 0.849609 10.2598 1.41602 10.2598 2.13867C10.2598 2.49023 10.3965 2.75391 10.6113 2.97852L12.4766 4.80469C12.1738 4.76562 11.8711 4.75586 11.5781 4.75586C6.65625 4.75586 2.75 8.67188 2.75 13.6133C2.75 18.5449 6.73438 22.5391 11.666 22.5391C16.5977 22.5391 20.582 18.5449 20.582 13.6133C20.582 12.8223 20.0254 12.2754 19.2539 12.2754C18.502 12.2754 17.9746 12.8223 17.9746 13.6133C17.9746 17.1094 15.1621 19.9219 11.666 19.9219C8.16992 19.9219 5.36719 17.1094 5.36719 13.6133C5.36719 10.0391 8.0918 7.25586 11.5781 7.25586C12.0176 7.25586 12.418 7.27539 12.7891 7.31445L10.6113 9.46289C10.3965 9.6875 10.2598 9.94141 10.2598 10.293C10.2598 11.0059 10.8164 11.5625 11.5195 11.5625Z",
    fill: "#878793"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.8aeb29e9c5b847ee5a64c0dea682cacf.svg";
export { ForwardRef as ReactComponent };